import { useQuery } from '@tanstack/react-query'

import { liveDashboardsService } from '../api/services/liveDashboards.service'
import { LIVE_URL } from '../products/Common/live/useLiveEmbed'
import { useCurrentSite } from '../store/store.hooks'
import { LiveDashboard } from '../types'

/** The current site's cloud dashboards sorted by name; empty when the live app is not configured. */
export function useSiteLiveDashboards() {
  const currentSite = useCurrentSite()

  return useQuery<LiveDashboard[]>({
    queryKey: ['liveDashboards', currentSite?.id],
    queryFn: () => liveDashboardsService.list(currentSite!.id),
    enabled: !!currentSite && !!LIVE_URL,
    select: (data) => [...data].sort((a, b) => a.Name.localeCompare(b.Name)),
  })
}
